import { translateText } from './translateText';

const isVisible = (element) => {
  return element.offsetParent !== null; // Ensure the element is visible before translating
};

// Custom translations (can be expanded)
const customTranslations = {
  'VIN': '车辆识别码',  
  'SUSPENSION': '悬挂', 
};

export const translateDOM = async (targetLang) => {
  const elements = document.querySelectorAll('*');
  const promises = [];

  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

  elements.forEach((element) => {
    if (!isVisible(element)) return;

    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const originalText = node.textContent.trim();

        if (originalText && !emailRegex.test(originalText)) {
          let modifiedText = originalText;
          
          // Apply predefined translations before API call
          Object.keys(customTranslations).forEach((word) => {
            const translation = customTranslations[word];
            modifiedText = modifiedText.replace(new RegExp(`\\b${word}\\b`, 'g'), translation);
          });

          // Translate the modified text
          const translatePromise = translateText(modifiedText, targetLang)
            .then((result) => {
              node.textContent = result.translatedText || modifiedText;
            });

          promises.push(translatePromise);
        }
      }
    });
  });

  await Promise.all(promises); // Ensure all translations complete before continuing
};
